//import { MbscModule } from '@mobiscroll/angular';
import { FormsModule } from '@angular/forms';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { HttpModule, Http } from '@angular/http';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { CommonService } from '../providers/common';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { IonicRatingModule } from 'ionic4-rating';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { FileOpener } from '@ionic-native/file-opener/ngx';


import { PaymentPage } from './payment/payment.page';
import { ServicesProvider } from 'src/providers/services';
import { MyDatePickerModule } from 'mydatepicker';
import { InViewportModule } from 'ng-in-viewport';
import { DatePipe } from '@angular/common';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { IgxCalendarModule, IgxDialogModule } from "igniteui-angular";
import { HammerModule } from "@angular/platform-browser";
//import { CalenderdesignPage } from "./calenderdesign/calenderdesign.page";
import { SocialSharing } from '@ionic-native/social-sharing/ngx';
import { CalenderComponent } from "./calender/calender.component";
import { File, FileEntry } from '@ionic-native/file/ngx';
import { Chooser } from '@ionic-native/chooser/ngx';
import { FileUploadService } from '../providers/upload';
import { FCM } from 'cordova-plugin-fcm-with-dependecy-updated/ionic/ngx';
import { AndroidPermissions } from '@ionic-native/android-permissions/ngx';
//import { Zoom } from '@ionic-native/zoom/ngx';
import { VideoCallService } from 'src/providers/videocall';
import { Geolocation } from '@ionic-native/geolocation/ngx';
//import { LaunchNavigator } from '@ionic-native/launch-navigator/ngx';
import { PopupalertPage } from './popupalert/popupalert.page';
import { FileTransfer } from '@ionic-native/file-transfer/ngx';
import { Media } from '@ionic-native/media/ngx';
import { CallNumber } from '@ionic-native/call-number/ngx';
//import { StreamingMedia } from '@ionic-native/streaming-media/ngx';
import { Camera, CameraOptions } from '@ionic-native/camera/ngx';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatButtonModule } from '@angular/material/button';
//import { FileOpener } from '@awesome-cordova-plugins/file-opener/ngx';
//import { SmsRetriever } from '@ionic-native/sms-retriever/ngx';
import { AddCall } from 'src/providers/addvCall';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { Payment } from 'src/providers/payment';
import { InAppBrowser, InAppBrowserOptions } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { HTTP } from '@awesome-cordova-plugins/http/ngx';
//import {RoundProgressModule} from 'angular-svg-round-progressbar';
//import { Ng2SearchPipeModule } from 'ng2-search-filter';
//for translation
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClientModule, HttpClient, } from '@angular/common/http';
import { Globalization } from '@ionic-native/globalization/ngx';
import { TranslateService } from '@ngx-translate/core';

import { MAT_DATE_LOCALE } from '@angular/material/core';
// import { BarcodeScannerOriginal } from '@ionic-native/barcode-scanner';
import { BarcodeScanner } from "@ionic-native/barcode-scanner/ngx";
import { QRScanner } from '@ionic-native/qr-scanner/ngx';
import { NgxQRCodeModule } from '@techiediaries/ngx-qrcode';
import { LocationAccuracy } from '@ionic-native/location-accuracy/ngx';
//import { FCM } from '@ionic-native/fcm/ngx';
// import { LocalNotifications } from '@ionic-native/local-notifications/ngx';
import { ELocalNotificationTriggerUnit, LocalNotifications } from '@ionic-native/local-notifications/ngx';
// export function HttpLoaderFactory(http: HttpClient) {
  // return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
  // return new TranslateHttpLoader(http, './assets/i18n/','.json');
  // return new TranslateHttpLoader(http, './assets/i18n/', '.json');
// }

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}

// export function HttpLoaderFactory(http: HttpClient) {
//   return new TranslateHttpLoader(http, '../assets/i18n/', '.json');
// }

import { CalendarModule } from 'ion2-calendar';
import { HomePageModule } from './home/home.module';
//import { ApplePay } from '@ionic-native/apple-pay/ngx'

@NgModule({
  declarations: [AppComponent,
    CalenderComponent],
  entryComponents: [],
  imports: [
    // MbscModule,
    FormsModule,
    HttpClientModule,
    BrowserModule,
    NgxQRCodeModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    }),

    IonicModule.forRoot({
      swipeBackEnabled: false
    }),
    AppRoutingModule,
    HttpModule,
    // HttpClientModule,

    InViewportModule,
    IonicRatingModule,
    MatExpansionModule,
    MatButtonModule,
    InfiniteScrollModule,
    MyDatePickerModule,
    NgCircleProgressModule.forRoot({
      radius: 100,
      outerStrokeWidth: 16,
      innerStrokeWidth: 8,
      outerStrokeColor: "#78C000",
      innerStrokeColor: "#C7E596",
      animationDuration: 300,
    }),

    BrowserAnimationsModule,
    IgxCalendarModule,
    HammerModule,
    IgxDialogModule,
    BrowserAnimationsModule,
    //Ng2SearchPipeModule,
    // RoundProgressModule
    CalendarModule,
    HomePageModule
  ],
  providers: [
    BarcodeScanner,
    QRScanner,
    File,
    FileOpener,
    AndroidPermissions,
    //ApplePay,
    // Zoom,
    VideoCallService,
    Chooser,
    FileUploadService,
    FCM,
    CommonService,
    SocialSharing,
    SplashScreen,
    StatusBar,
    Camera,
    PopupalertPage,
    LocalNotifications,
    TranslateService,
    Globalization,
    HttpClient,

    // CalenderdesignPage,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: MAT_DATE_LOCALE, useValue: 'ar' },
    PaymentPage,
    Payment,
    ServicesProvider,
    DatePipe,
    Geolocation,
    //LaunchNavigator,
    FileTransfer,
    Media,
    CallNumber,
    // StreamingMedia,
    //SmsRetriever,
    AddCall,
    InAppBrowser,
    HTTP,
    LocationAccuracy,
       //FileOpener
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule {
  constructor(
    private _translate: TranslateService) {
    this._translate.addLangs(["en", "ea"]);
    _translate.setDefaultLang('en');
    _translate.use('en');
  }
}

